// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publicdata-container {
  padding: 30px;
}

.publicdata-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 25px;
  margin-top: 30px;
}

.publicdata-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.publicdata-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 14px rgba(0,0,0,0.12);
}

.publicdata-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.publicdata-comingsoon {
  margin-top: 15px;
  font-weight: bold;
  color: #cc0000;
}

/* Toolbar above the source cards (Previous Downloads entry point). */
.publicdata-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
.publicdata-previous-btn {
  background: #213a22;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 600;
  cursor: pointer;
}
.publicdata-previous-btn:hover { background: #2f4f4d; }
`, "",{"version":3,"sources":["webpack://./src/css/PublicDataPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA,iCAAiC,mBAAmB,EAAE","sourcesContent":[".publicdata-container {\n  padding: 30px;\n}\n\n.publicdata-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 25px;\n  margin-top: 30px;\n}\n\n.publicdata-card {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 25px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.08);\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.publicdata-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 14px rgba(0,0,0,0.12);\n}\n\n.publicdata-card.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.publicdata-comingsoon {\n  margin-top: 15px;\n  font-weight: bold;\n  color: #cc0000;\n}\n\n/* Toolbar above the source cards (Previous Downloads entry point). */\n.publicdata-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n}\n.publicdata-previous-btn {\n  background: #213a22;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 9px 18px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.publicdata-previous-btn:hover { background: #2f4f4d; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
